<template>
	<div class="container">
		<div class="page-header">
			<h2 class="h2">Adicionar Lead</h2>
			<router-link to="/dashboard" class="btn btn-secondary">Voltar</router-link>
		</div>

		<div class="card">
			<div class="candidate-form">
				<div class="form-row">
					<div class="form-group">
						<label for="nome">Nome Completo *</label>
						<input type="text" id="nome" v-model="formData.nome" required placeholder="Nome completo" />
					</div>

					<div class="form-group">
						<label for="idade">Idade *</label>
						<input type="number" id="idade" v-model="formData.idade" required placeholder="Idade" />
					</div>

					<div class="form-group">
						<label for="telefone">Telefone *</label>
						<input type="tel" id="telefone" v-model="formData.telefone" required
							placeholder="(11) 99999-9999" @input="formatPhone" />
					</div>

					<div class="form-group">
						<label for="responsavel">Responsável (se menor de idade)</label>
						<input type="text" id="responsavel" v-model="formData.responsavel"
							placeholder="Nome do responsável" />
					</div>

					<div class="form-group">
						<label for="responsavel">Observação</label>
						<textarea id="observacao" name="observacao" rows="5" cols="33" placeholder="Observação"
							v-model="formData.observacao"></textarea>
						<span class="caracteres-restantes">{{ 500 - formData.observacao.length }} caracteres
							restantes</span>
					</div>

					<div class="form-group">
						<label for="local">Local</label>
						<input type="text" id="local" v-model="formData.local" placeholder="Local" />
					</div>

					<div class="form-group">
						<label for="cidade">Cidade</label>
						<input type="text" id="cidade" v-model="formData.cidade" required placeholder="Cidade" />
					</div>

					<div class="form-group">
						<label for="estado">Estado</label>
						<input type="text" id="estado" v-model="formData.estado" placeholder="Estado" />
					</div>
				</div>

				<div class="error" v-if="error">{{ error }}</div>
				<div class="success" v-if="success">{{ success }}</div>

				<div class="form-actions">
					<button @click="cadastrar()" class="btn btn-primary">Salvar</button>
					<button @click="duplicar()" class="btn btn-secondary" v-show="buttonDuplicar">
						Duplicar
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();

const formData = reactive({
	nome: "",
	idade: "",
	telefone: "",
	responsavel: "",
	cidade: "",
	local: "",
	estado: "",
	observacao: "",
})
const error = ref("");
const success = ref("");
const buttonDuplicar = ref(true);

function validaCampos() {
	if (
		formData.nome == "" ||
		formData.idade == "" ||
		formData.telefone == "" ||
		formData.cidade == "" ||
		formData.estado == ""
	) {
		error.value = "Você precisa preencher os campos obrigatórios";
		return false;
	}
	if (formData.idade < 18 && !formData.responsavel.trim()) {
		error.value = "Para menores de 18 anos, o responsável é obrigatório";
		return false;
	}

	return true;
}

function cadastrar() {
	if (!validaCampos()) return;
	salvarOffline();
	success.value =
		"Candidato salvo offline. Será enviado quando sincronizar.";
	limparForm();
	buttonDuplicar.value = true;
}
function duplicar() {
	if (!validaCampos()) return;
	salvarOffline();
	success.value =
		"Candidato duplicado. Faça as alterações e salve o novo candidato";
	buttonDuplicar.value = false;
	formData.nome = "";
	formData.idade = "";
}
function salvarOffline() {
	let idUsuario = Date.now().toString(36) + Math.random().toString(36).substr(2);
	const leadsOffline = JSON.parse(
		localStorage.getItem("leads_offline") || "[]"
	);
	error.value = "";

	const nomeFormatado = formData.nome
		.toLowerCase()
		.replace(/\./g, '')
		.replace(/\s+/g, '.')
		.replace(/\.+/g, '.');

	const novoLead = {
		id: idUsuario,
		idade: parseInt(formData.idade),
		telefone: formData.telefone.replace(/\D/g, ""),
		email:
			nomeFormatado +
			formData.telefone.replace(/\D/g, "") +
			"@sememail.com.br",
		...formData,
		enviado_bubble: false,
		created_at: getDateTimeBrasil(),
	};
	leadsOffline.push(novoLead);
	localStorage.setItem("leads_offline", JSON.stringify(leadsOffline));

	setTimeout(() => {
		success.value = "";
	}, 5000);
}
function getDateTimeBrasil() {
	const date = new Date();

	const brasilDate = new Date(date.toLocaleString('en-US', {
		timeZone: 'America/Sao_Paulo'
	}));

	const year = brasilDate.getFullYear();
	const month = String(brasilDate.getMonth() + 1).padStart(2, '0');
	const day = String(brasilDate.getDate()).padStart(2, '0');
	const hours = String(brasilDate.getHours()).padStart(2, '0');
	const minutes = String(brasilDate.getMinutes()).padStart(2, '0');
	const seconds = String(brasilDate.getSeconds()).padStart(2, '0');

	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}
function limparForm() {
	formData.nome = "";
	formData.idade = "";
	formData.telefone = "";
	formData.responsavel = "";
	formData.observacao = "";
}
function formatPhone(event) {
	let value = event.target.value.replace(/\D/g, "");
	if (value.length <= 11) {
		value = value.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
	}
	formData.telefone = value;
}

onMounted(() => {
	const getLocal = JSON.parse(localStorage.getItem("local")) || "";
	if (!getLocal) {
		router.push("/definir-local");
	}
	formData.local = getLocal.local;
	formData.cidade = getLocal.cidade;
	formData.estado = getLocal.estado;
})
</script>

<style scoped>
.page-header {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 2rem;
}

.candidate-form {
	max-width: 800px;
}

.form-row {
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 2rem;
	margin-bottom: 1rem;
}

.form-actions {
	display: flex;
	gap: 1rem;
	margin-top: 2rem;
}

@media (max-width: 768px) {
	.page-header {
		gap: 1rem;
	}

	.form-row {
		grid-template-columns: 1fr;
		gap: 0;
	}

	.form-actions {
		flex-direction: column;
	}
}
</style>
